<template>
  <v-container fluid>
    <v-toolbar>
      <v-toolbar-title>{{ $t('NAVIGATION.APP_CONTENT') }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn dark color="indigo" @click="dialog = true">
        <v-icon left>mdi-plus</v-icon>
        {{ $t('ITEM.NEW') }}
      </v-btn>
    </v-toolbar>

    <v-sheet class="pa-5" tile>
      <app-content-list-filter :value="filters" @setRequest="setFilters" />

      <app-content-list
        :meta="meta"
        :app-contents="appContents"
        :options.sync="options"
        @edit="edit"
      />
    </v-sheet>

    <v-dialog v-if="dialog" v-model="dialog" max-width="500px">
      <v-card flat dense>
        <v-card-title
          >{{ $t('APP_CONTENT.LIST_HEADER') }}

          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle class="pb-3">{{
          $t('APP_CONTENT.LIST_SUBHEADER')
        }}</v-card-subtitle>
        <v-card-text
          ><types-list @close="dialog = !dialog"> </types-list
        ></v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import contentRoutes from '@/modules/app_content/common/content-types-routes';
import DataOptions from '@/modules/_global/classes/DataOptions';
import { mapActions } from 'vuex';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import { debounce } from 'lodash';
import AppContentListFilter from '@/modules/app_content/components/AppContentListFilter';

const routes = contentRoutes;

const DEBOUNCE_DELAY = 300;

export default {
  name: 'AppContent',

  components: {
    AppContentListFilter,
    AppContentList: () =>
      import('@/modules/app_content/components/AppContentList.vue'),
    TypesList: () =>
      import('@/modules/app_content/pages/AppContentTypesListPage.vue')
  },

  mixins: [i18nRefreshData],

  data: () => ({
    dialog: false,
    filters: {},
    meta: {},
    appContents: [],
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ['id'],
      sortDesc: [false],
      groupBy: [],
      groupDesc: [],
      mustSort: false,
      multiSort: false
    }
  }),

  computed: {
    preparedOptions() {
      return DataOptions.createFromObject(this.options).toBackendFormat();
    },

    params() {
      return Object.assign({}, this.filters, this.preparedOptions);
    }
  },

  watch: {
    options: {
      deep: true,
      immediate: true,
      handler() {
        this.refreshData();
      }
    },
    filters: {
      deep: true,
      handler() {
        this.options.page = 1;
        this.refreshData();
      }
    }
  },

  methods: {
    ...mapActions('appcontent', ['getAppContents', 'appContentTypes']),

    refreshData: debounce(function debouncedGetData() {
      this.getAppContents(this.params).then(({ data }) => {
        this.appContents = data.data;
        this.meta = data.meta;
      });
    }, DEBOUNCE_DELAY),

    setFilters(filters) {
      this.filters = filters;
    },

    edit(item) {
      const route = routes[item.type_id];

      if (!route) {
        return;
      }

      this.$router.push({
        name: route,
        params: { id: item.id }
      });
    }
  }
};
</script>
